<template>
    <sp-form
        class="mobile-general-form-single-upload"
        :class="`uuid-${config.uuid}`"
        ref="elForm"
        v-show="!hideVideoComp"
        :model="formModel"
        :rules="rules"
    >
        <sp-form-item prop="file">
            <form-group
                :title="i18nLabel"
                :class="{ 'hide-title': !!props.hideTitle || globalModel.preview,
                          'show-title': !props.hideTitle && !globalModel.preview && errorMsg }"
            >
                <sub-title class="mt4" v-if="lastShowRejectTip(i18nLabel)" :errorMsg="outputError(i18nLabel)"></sub-title>
                <sub-title :errorMsg="errorMsg"></sub-title>
                <card-upload
                    :sample-image="props.sampleImageSrc"
                    :tip="i18n(props.hint)"
                    :value="`${value}`"
                    :preview="previewImg"
                    :valueImg="valueImg"
                    :readonly="readonly"
                    :error="error"
                    :tip-error="error && i18n(error.message)"
                    :tip-retry="i18n(props.tipRetry)"
                    :is-uploading="isUploading"
                    @select="onUploadSelect"
                    @preview="onPreviewClick"
                    @clear="onUploadClear"
                ></card-upload>
            </form-group>
            <input
                class="mobile-general-form-single-upload__input"
                type="file"
                ref="input"
                :multiple="false"
                :accept="props.accept"
                @change="onInputChange"
            />
        </sp-form-item>
        <img-previewer
            ref="imgPreviewerRef"
            :previewList="previewList"
            @on-delete-file="onUploadClear"
            :noticeFormPreview="globalModel.noticeFormPreview"
        ></img-previewer>
    </sp-form>
</template>
<script>
import { Form, FormItem } from '@ks/sharp-ui';
import FormGroup from '@ks/sharp-comp-form-group';
import '@ks/sharp-comp-form-group/lib/themes/default/index.css';
import CardUpload from '@ks/sharp-comp-card-upload';
import '@ks/sharp-comp-card-upload/lib/themes/default/index.css';
import {
    getValueByPath,
    IMAGE_FILE_TYPES,
    UPLOAD_FILE_PLACEHOLDER_SRC,
    composeUrlWithParam,
} from '../../utils';
import ImgPreviewer from '../component-base/common/img-previewer';
import ComponentBase from '../component-base';
import { component } from './props';
import { $fileUploader } from '../component-base/xhr';
import SubTitle from '../component-base/common/sub-title';
import formEventBus, { FORM_EVENTS_TYPE } from '../../utils/event-bus';

const videoExtensions = /\.(mp4|mpg|mpeg|mov)$/i;

export default {
    name: component,
    components: {
        SpForm: Form,
        SpFormItem: FormItem,
        FormGroup,
        CardUpload,
        ImgPreviewer,
        SubTitle,
    },
    extends: ComponentBase,
    data() {
        return {
            formModel: {
                // 当auto-upload打开时，这个值存上传后获得的fileId，否则存文件本身
                file: null,
            },
            valueImgFile: '',
            isUploading: false,
            error: null,
            // 预览图
            showPreview: false,
            previewList: [],
            errorMsg: '',
        };
    },
    created() {
        this._fileUploader = null;
    },
    computed: {
        // 校验规则仅判断文件个数是否符合要求
        rules() {
            const fileRules = [];
            fileRules.push({
                required: !!this.props.required,
                message: this.i18n(this.props.errRequired, this.i18nLabel) || `必须上传${this.i18nLabel}`,
            });

            return {
                file: fileRules,
            };
        },
        extraParams() {
            return this.globalModel.globalParams ? {
                ...this.globalModel.globalParams,
            } : {
                ...this.$route.params,
                ...this.$route.query,
            };
        },
        previewImg() {
            return this.isUploading || this.error ? this.valueImgFile || UPLOAD_FILE_PLACEHOLDER_SRC : '';
        },
        value() {
            if (this.props.autoUpload) {
                return this.formModel.file || '';
            }
            return this.formModel.file && this.formModel.file.name || '';
        },
        valueImg() {
            if (!this.formModel.file) {
                return '';
            }
            if (this.formRoot.uploadPreviewMethod) {
                return this.formRoot.uploadPreviewMethod(
                    this.formModel.file,
                    this.config,
                );
            }
            if (!this.props.autoUpload) {
                return this.valueImgFile;
            }
            if (this.props.previewSrc) {
                console.log('originPreviewSrc', this.props.previewSrc);
                // 附加参数逻辑同API组件
                return composeUrlWithParam(this.props.previewSrc + '&from={from}&type={type}', {
                    ...this.extraParams,
                    ...this.globalModel.formData,
                    file: this.formModel.file,
                    type: this.globalModel.viewType || 0,
                });
            }
            return UPLOAD_FILE_PLACEHOLDER_SRC;
        },
        readonly() {
            return this.notChanged || this.globalModel.preview || this.globalModel.hideSubmitStyle;
        },
        hideVideoComp() {
            if (this.props.hide) {
                return true;
            }
            // 如果hide为false，正常展示，但是公告表单预览模式下，如果是视频文件，则隐藏整个组件
            if (this.globalModel.noticeFormPreview && videoExtensions.test(this.valueImg)) {
                return true;
            }
            return false;
        },
    },
    watch: {
        async valueImg(val) {
            this.previewList = await this.getPreviewList(val);
        },
    },
    methods: {
        async getPreviewList(src) {
            const p = new Promise(resolve => {
                const image = new Image();
                image.onload = () => {
                    resolve({
                        src,
                        w: image.width,
                        h: image.height,
                    });
                };
                image.onerror = () => {
                    resolve({
                        src,
                        w: 1080,
                        h: 1080,
                    });
                };
                image.src = src;
            });
            const res = await p;
            return [res];
        },
        onPreviewClick() {
            if (this.notChanged) {return;}
            this.$refs.imgPreviewerRef.showIndex(0);
        },
        async readFileImg(file) {
            const reader = new Promise(resolve => {
                const fileReader = new FileReader();
                fileReader.onload = function (e) {
                    resolve(e.target.result);
                };
                fileReader.readAsDataURL(file);
            });
            this.valueImgFile = await reader;
        },
        updatePreview(file) {
            if (!file) {
                return;
            }
            if (IMAGE_FILE_TYPES.includes(file.type)) {
                this.readFileImg(file);
                return;
            }
            this.valueImgFile = '';
        },
        onUploadClear() {
            if (this._fileUploader) {
                this._fileUploader._aborted = true;
            }
            this.formModel.file = null;
            this.isUploading = false;
            this.error = null;
            this.onFileChange();
            // this.validate();
            this.$emit('delete-file');
        },
        onUploadSelect() {
            if (!this.notChanged) {
                // 上报点击
                this.logger('upload-click');
                this.$refs.input.value = null;
                this.$refs.input.click();
            }
        },
        onInputChange(ev) {
            const files = ev.target.files;
            if (!files) {
                formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CUSTOM', 'SELECT_FILE_FAILED', {
                    error_msg: 'file empty',
                });
                return;
            }
            this.onFileSelect(files[0]);
        },
        onBeforeUpload(file) {
            // 检查是否超过大小限制
            if (!this.props.maxSize) {
                return !!file;
            }
            // 最大值单位是kb
            const sizeOk = file.size / 1024 <= this.props.maxSize;
            if (!sizeOk) {
                this.setError(this.i18n(this.props.errSizeExceed) || '超出大小限制');
            } else {
                this.setError();
            }
            return sizeOk;
        },
        async onFileSelect(file) {
            if (!this.onBeforeUpload(file)) {
                return;
            }

            // 上报用户选择的文件信息
            const logFileInfo = {
                name: file.name,
                size: file.size,
                type: file.type,
            };
            this.logger('upload-select', logFileInfo);

            this.updatePreview(file);
            if (this.props.autoUpload) {
                // console.log(file);
                const uploader = this._fileUploader = this.uploadFile(file);
                this.isUploading = true;
                try {
                    const data = await uploader;
                    if (uploader._aborted) {
                        return;
                    }
                    this.isUploading = false;
                    if (this.props.pickKey) {
                        this.formModel.file = getValueByPath(data, this.props.pickKey);
                    } else {
                        this.formModel.file = data;
                    }
                    formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CUSTOM', 'UPLOAD_FILE_SUCCESS', {
                        fileKey: this.formModel.file,
                    });
                    this.error = null;
                    // 上报成功
                    this.logger('upload-success', {
                        ...logFileInfo,
                        fileKey: this.formModel.file,
                    });
                } catch (e) {
                    formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CUSTOM', 'UPLOAD_FILE_FAILED', {
                        error_msg: String(e),
                    });
                    if (uploader._aborted) {
                        return;
                    }
                    this.isUploading = false;
                    this.error = e;
                    // 上报失败
                    this.logger('upload-fail', logFileInfo);
                    return;
                }
            } else {
                this.formModel.file = file;
            }
            this.onFileChange();
            // this.validate();
            this.$emit('upload-success');
        },
        onFileChange() {
            this.setSelfFormDataValue(this.formModel.file) && this.$emit('change');
        },
        async uploadFile(file) {
            // console.log(file);
            let data;
            if (typeof this.formRoot.handleUploadAction === 'function') {
                // 使用外部传入的上传方法
                this._fileUploader = this.formRoot.handleUploadAction(
                    file,
                    this.config
                );
                data = await this._fileUploader;
            } else {
                // 默认的上传方法
                const url = composeUrlWithParam(this.props.action, {
                    ...this.extraParams,
                    ...this.globalModel.formData,
                });

                const payload = new FormData();
                payload.append(this.props.fileName, file);
                payload.append('from', this.extraParams.from);
                this._fileUploader = $fileUploader.post(
                    url,
                    payload
                );
                data = (await this._fileUploader).data;
                if (!data || 1 !== data.result) {
                    // i18n在传入属性的时候调用，这里忽略
                    const errMsg = data.error_msg || this.props.errNetwork || '网络错误';
                    throw new Error(errMsg);
                }
            }
            return data;
        },
        setError(msg) {
            if (msg) {
                this.error = new Error(msg);
            } else {
                this.error = null;
            }
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            if (typeof newValue === 'undefined') {
                // 默认值逻辑
                if (this.formModel.file) {
                    this.formModel.file = null;
                }
                this.onFileChange();
                // this.validate();
                return;
            }

            if (typeof newValue === 'string' || newValue === null) {
                // 这里只考虑用fileId或被清空的情况，file对象难以比较
                if (this.formModel.file !== newValue) {
                    this.formModel.file = newValue;
                    // 数据被动修改同样抛出change事件
                    this.$emit('change');
                    // this.validate();
                }
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            if (this.error) {
                // this.validateFailureHandler();
                this.toastAndLog(this.error.message);
                return false;
            }
            if (this.isUploading) {
                // this.validateFailureHandler(this.i18n(this.props.errUpload, this.i18nLabel) || `请检查${this.i18nLabel}`);
                this.toastAndLog(this.i18n(this.props.errUpload, this.i18nLabel) || `请检查${this.i18nLabel}`);
                return false;
            }
            const promise = new Promise((resolve, reject) => {
                this.$refs.elForm.validate((valid, invalidFields) => {
                    valid ? resolve(valid) : reject(invalidFields);
                });
            });
            try {
                return await promise;
            } catch (e) {
                this.errorMsg = e.file[0].message;
                this.validateFailureHandler(e.file[0].message);
                return false;
            }
        },
        clearValidate() {
            this.errorMsg = '';
            this.$refs.elForm && this.$refs.elForm.clearValidate();
        },
    },
};
</script>
<style lang="less" scoped>
@import '../../style.less';
.mobile-general-form-single-upload {
    padding: 16px 0;
    /deep/ .spc-form-group h2 {
        padding: 0 0 !important;
    }
    /deep/ .sp-form {
        &-item {
            padding: 1rem 0;
        }
        &-item__error {
            // width: 100%;
            // text-align: center;
            // top: 0;
            // right: auto;
            // left: 0 !important;
            // transform: translateY(100%) !important;
            display: none !important;
        }
    }
    &__input {
        display: none;
    }
    /deep/ .spc-card-upload {
        margin-top: 12px !important;
    }
}
</style>
